module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/pharmacy/pharmacy.component.css
// module id = ./src/app/Pages/tasks/pharmacy/pharmacy.component.css
// module chunks = main